import DynamicImport from "../components/v3/dynamic-import/DynamicImport";
import React from "react";

// [DY] 05/27/2020 can move to using React.lazy once Suspense is production ready and stable
// https://reactjs.org/docs/code-splitting.html#route-based-code-splitting
// const SubscriptionFormContainer = lazy(() => import("../containers/v3/SubscriptionFormContainer"));

export const AppleNewsSocial = (props) => (
    <DynamicImport
        name="AppleNewsSocial"
        importComponent={ () => import(/* webpackChunkName: "appleNewsSocial" */ "../containers/AppleNewsSocial") }
        { ...props }
    />
);

export const TerminalSignIn = (props) => (
    <DynamicImport
        name="TerminalSignIn"
        importComponent={ () => import(/* webpackChunkName: "terminalSignIn" */ "../containers/v2/TerminalSignIn") }
        { ...props }
    />
);

export const NewsletterRedesign = (props) => (
    <DynamicImport
        name="NewsletterRedesign"
        importComponent={ () => import(/* webpackChunkName: "newsletterRedesign" */ "../containers/v2/NewsletterManagementContainer") }
        { ...props }
    />
);

export const Watchlist = (props) => (
    <DynamicImport
        name="Watchlist"
        importComponent={ () => import(/* webpackChunkName: "watchlist" */ "../containers/Watchlist") }
        { ...props }
    />
);

export const Magazines = (props) => (
    <DynamicImport
        name="Magazines"
        importComponent={ () => import(/* webpackChunkName: "magazines" */ "../containers/Magazines") }
        { ...props }
    />
);

export const LinkSubscription = (props) => (
    <DynamicImport
        name="LinkSubscription"
        importComponent={ () => import(/* webpackChunkName: "linkSubscription" */ "../containers/LinkSubscription") }
        { ...props }
    />
);

export const OffersContainer = (props) => (
    <DynamicImport
        name="OffersContainer"
        importComponent={ () => import(/* webpackChunkName: "offersContainer" */ "../containers/v3/OffersContainer") }
        { ...props }
    />
);

export const OfferSuccessContainer = (props) => (
    <DynamicImport
        name="OfferSuccessContainer"
        importComponent={ () => import(/* webpackChunkName: "offerSuccessContainer" */ "../containers/v3/OfferSuccessContainer") }
        { ...props }
    />
);

export const SubscriptionFormContainer = (props) => (
    <DynamicImport
        name="SubscriptionFormContainer"
        importComponent={ () => import(/* webpackChunkName: "subscriptionFormContainer" */ "../containers/v3/SubscriptionFormContainer") }
        { ...props }
    />
);

export const SubscriptionSuccessContainer = (props) => (
    <DynamicImport
        name="SubscriptionSuccessContainer"
        importComponent={ () => import(/* webpackChunkName: "subscriptionSuccessContainer" */ "../containers/v3/SubscriptionSuccessContainer") }
        { ...props }
    />
);

export const Account = (props) => (
    <DynamicImport
        name="Account"
        importComponent={ () => import(/* webpackChunkName: "account" */ "../containers/Account") }
        { ...props }
    />
);

export const BulkSubscriptionFormContainer = (props) => (
    <DynamicImport
        name="BulkSubscriptionFormContainer"
        importComponent={ () => import(/* webpackChunkName: "bulkSubscriptionFormContainer" */ "../containers/v3/BulkSubscriptionFormContainer") }
        { ...props }
    />
);

export const CounterOffersContainer = (props) => (
    <DynamicImport
        name="CounterOffersContainer"
        importComponent={ () => import(/* webpackChunkName: "counterOffersContainer" */ "../containers/v3/CounterOffersContainer") }
        { ...props }
    />
);

export const OnboardingContainer = (props) => (
    <DynamicImport
        name="OnboardingContainer"
        importComponent={ () => import(/* webpackChunkName: "onboarding" */ "../containers/v3/OnboardingContainer") }
        { ...props }
    />
);

export default {
    AppleNewsSocial,
    TerminalSignIn,
    NewsletterRedesign,
    Watchlist,
    Magazines,
    LinkSubscription,
    OffersContainer,
    OfferSuccessContainer,
    SubscriptionFormContainer,
    SubscriptionSuccessContainer,
    Account,
    BulkSubscriptionFormContainer,
    CounterOffersContainer
};
